import React, { useEffect } from 'react';
import  { Redirect } from 'react-router-dom'
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, withStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { ToggleButtonGroup , ToggleButton } from '@material-ui/lab';
import useToken from '../../useToken';
import deleteToken from '../../deleteToken'
import { useAuth } from '../../contexts/AuthContext'
import { useSelector, useDispatch } from 'react-redux';
import { fetchData } from '../../features/cultivation_models/cultivationModelSlice';
import { Select, MenuItem, InputLabel, FormControl, Button } from '@material-ui/core';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import CultivationView from './CultivationView';
const theme = createTheme({
  palette: {
    primary: { main: green[500], contrastText: "#fff" },
  },
});
const useStyles = makeStyles ({
      root: {
              display: 'flex',
            },
      toolbar: {
              paddingRight: 24, // keep right padding when drawer closed
            },
      toolbarIcon: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              padding: '0 8px',
            },
      menuButton: {
              marginRight: 36,
            },
      menuButtonHidden: {
              display: 'none',
            },
      title: {
              flexGrow: 1,
            },
      content: {
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            },
      container: {
              paddingTop: 1,
              paddingBottom: 1,
            },
      paper: {
              display: 'flex',
              flexDirection: 'column',
            },
      fixedHeight: {
              height: 400,
            },
      formControl: {
        margin: 10,
        marginLeft: 30,
        minWidth: 300,
      },
      buttonMargin: {
        marginTop: 20,
      },
      selectEmpty: {
        marginTop: 10,
      },
});

const CultivationModels = () => {
  const { logout } = useAuth()
  const [model, setModel] = React.useState("Southwest Monsoon Season (Jun-Sep)")
  const [crop, setCrop] = React.useState("Xiao Bai Cai")

  const {token, setToken} = useToken()
  const dispatch = useDispatch()
  const models = useSelector((state: any) => state.cultivation_models.cultivationData);
  useEffect(() => {
    dispatch(fetchData({token}))
  }, [dispatch]);
  const cultivationModels = models.cultivationModels || [];
  const crops = models.crops || [];

    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    
    const handleModel = (event, newModel) => {
      if (newModel != null) {
        setModel(newModel)
      }
    }

    const handleCrop = (event, newCrop) => {
      if (newCrop != null) {
        setCrop(newCrop)
      }
    }

    if (models.status === "idle") { 
      if (models.error === "unauthorized") {
        logout()
        window.location.reload();
      }
        return (
         <Container maxWidth="lg" className={classes.container}>
         <h1>Cultivation Models</h1>

         <Grid container>
         <Grid item xs={12}>
         <ToggleButtonGroup
         value={crop}
         exclusive
         onChange={handleCrop}
         crop-label={crop} >
          { 
              crops.map((crop, index) => {
                return (
                  <ToggleButton value={crop} crop-label={crop}>
                  {crop}
                  </ToggleButton>
                )
              }
          )}
        </ToggleButtonGroup>
        </Grid>
        </Grid>
        
        <hr/>

        <Grid container>
        <Grid item xs={12}>
         <ToggleButtonGroup
         value={model}
         exclusive
         onChange={handleModel}
         model-label={model} >
          { 
              cultivationModels.map((model, index) => {
                return (
                  <ToggleButton value={model} model-label={model}>
                  {model}
                  </ToggleButton>
                )
              }
          )}
        </ToggleButtonGroup>
        </Grid>
        </Grid>

        <br/>

        <Grid container>
        <Grid item xs={12}>
        <CultivationView data={{models, crop, model}}/>
        </Grid>
        </Grid>
         <Box pt={4}>
         </Box>
         </Container>

        )
    } else {
      return (<h3> loading </h3>)
    }
  }

export default CultivationModels
